// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__FZAlq","info":"styles_info__1yBgM","label":"styles_label__pm6Cb","line":"styles_line__3No-n","button":"styles_button__1QH7w"};